(function () {
  document.querySelectorAll("[data-voix-porte]").forEach(function (S) {
    var data = JSON.parse(S.querySelector("[data-lieux]").textContent);
    var L = data.lieux;
    var voix = data.lien;
    var duree = data.duree || 8000;
    var fond = S.querySelector("[data-fond]");
    var couloir = S.querySelector("[data-couloir]");
    var prog = S.querySelector("[data-prog]");
    var reduit = matchMedia("(prefers-reduced-motion: reduce)").matches;
    var i = -1, t0 = 0, pause = false, visible = false, mainOn = 0;
    var start = 0;
    L.forEach(function (l, k) { if (l.key === data.premiere) start = k; });

    var ims = L.map(function () {
      var d = document.createElement("div");
      d.className = "im";
      fond.appendChild(d);
      return d;
    });
    function petit(u) {
      return /commons\.wikimedia\.org/.test(u) ? u.replace(/\?width=\d+/, "?width=320") : u;
    }
    function charge(k) {
      k = (k + L.length) % L.length;
      var d = ims[k];
      var u = L[k].u;
      if (d.dataset.u !== u) {
        d.dataset.u = u;
        d.style.backgroundImage = "url('" + u.replace(/'/g, "%27") + "')";
      }
      d.style.backgroundPosition = L[k].pos || "50% 50%";
    }
    var portes = L.map(function (l, k) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "mvp-pm";
      b.setAttribute("role", "tab");
      b.dataset.rom = l.rom;
      b.dataset.nom = l.nom;
      b.title = l.nom + " · " + l.pays;
      b.style.backgroundImage = "url('" + petit(l.u).replace(/'/g, "%27") + "')";
      b.style.backgroundPosition = l.pos || "50% 50%";
      b.addEventListener("click", function () { aller(k, true); });
      couloir.appendChild(b);
      return b;
    });
    function q(name) { return S.querySelector("[data-" + name + "]"); }
    var entrerLien = S.querySelector(".mvp-gestes a");
    var entrerHref = entrerLien ? entrerLien.getAttribute("href") : "";
    function avantOuverture() {
      if (!data.open_at || !data.acces) return false;
      var ouvre = Date.parse(data.open_at);
      return !isNaN(ouvre) && Date.now() < ouvre;
    }
    function remplis(l) {
      q("rom").textContent = l.rom;
      q("pays").textContent = l.pays.toUpperCase();
      q("nom").textContent = l.nom;
      q("seuil").textContent = l.seuil;
      q("verbe").textContent = l.verbe + ".";
      q("titre").textContent = " " + l.oeuvre;
      q("an").textContent = l.an ? "· " + l.an : "";
      var url = voix + l.key;
      var oeuvre = q("oeuvre");
      var salle = q("salle");
      var label = q("acces-label");
      var avant = avantOuverture();
      if (avant) {
        oeuvre.href = data.acces;
        salle.href = data.acces;
        if (label) {
          label.hidden = false;
          label.textContent = data.acces_label;
        }
        oeuvre.classList.add("is-avant");
        if (entrerLien) entrerLien.href = data.acces;
      } else {
        oeuvre.href = url;
        salle.href = url;
        if (label) label.hidden = true;
        oeuvre.classList.remove("is-avant");
        if (entrerLien) entrerLien.href = entrerHref;
      }
      var tab = q("tab");
      if (l.produit) {
        tab.hidden = false;
        tab.replaceChildren();
        var verbe = document.createElement("b");
        verbe.textContent = data.gout || "Goûter.";
        tab.appendChild(verbe);
        tab.appendChild(document.createTextNode(" " + l.produit[0] + " \u2197"));
        tab.href = l.produit[1];
      } else tab.hidden = true;
      q("cartel").innerHTML = "<b>" + l.cap + "</b> " + l.cr;
    }
    function aller(n, main) {
      var prem = i < 0;
      i = (n + L.length) % L.length;
      var l = L[i];
      charge(i); charge(i + 1); charge(i - 1);
      ims.forEach(function (d, k) { d.classList.toggle("on", k === i); });
      var lieu = q("lieu");
      var cartel = q("cartel");
      if (prem || reduit) remplis(l);
      else {
        lieu.classList.add("mvp-chg");
        cartel.style.opacity = 0;
        setTimeout(function () {
          remplis(l);
          lieu.classList.remove("mvp-chg");
          cartel.style.opacity = "";
        }, 380);
      }
      portes.forEach(function (b, k) {
        if (k === i) b.setAttribute("aria-current", "true");
        else b.removeAttribute("aria-current");
      });
      var b = portes[i];
      couloir.scrollTo({ left: b.offsetLeft - couloir.clientWidth / 2 + b.offsetWidth / 2, behavior: prem ? "auto" : "smooth" });
      t0 = performance.now();
      if (main) {
        clearTimeout(mainOn);
        pause = true;
        mainOn = setTimeout(function () { pause = false; mainOn = 0; t0 = performance.now(); }, 14000);
      }
    }
    function tick(now) {
      if (!reduit && !pause && visible && i >= 0) {
        var p = (now - t0) / duree;
        prog.style.width = Math.min(100, p * 100) + "%";
        if (p >= 1) aller(i + 1);
      }
      requestAnimationFrame(tick);
    }
    S.querySelector("[data-prev]").addEventListener("click", function () { aller(i - 1, true); });
    S.querySelector("[data-next]").addEventListener("click", function () { aller(i + 1, true); });
    S.addEventListener("mouseenter", function () { pause = true; });
    S.addEventListener("mouseleave", function () { if (!mainOn) { pause = false; t0 = performance.now(); } });
    S.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") aller(i + 1, true);
      if (e.key === "ArrowLeft") aller(i - 1, true);
    });
    var x0 = null;
    S.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    S.addEventListener("touchend", function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) aller(dx < 0 ? i + 1 : i - 1, true);
      x0 = null;
    });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible = e.isIntersecting; if (visible) t0 = performance.now(); });
    }, { threshold: 0.45 }).observe(S);
    aller(start, false);
    requestAnimationFrame(tick);
  });
})();
